import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  // Falha barulhenta e imediata. Sem isto a aplicação arranca normalmente e
  // só rebenta na primeira query, com um erro de rede indecifrável — tipicamente
  // depois de um deploy em que se esqueceu de configurar as variáveis no CI.
  throw new Error(
    "VITE_SUPABASE_URL e/ou VITE_SUPABASE_PUBLISHABLE_KEY ausentes no build. " +
      "Em local: copiar .env.example para .env.local. " +
      "No CI: definir como repository Variables no GitHub.",
  );
}

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
    },
  },
);
